import React, {useState} from 'react';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import Dropdown from '../../component/DropDown/DropDown';
import SearchInput from '../../component/SearchInput/SearchInput';
import {Times, ViewPen} from '../../assets/icons';
import styles from '../../styles/PartnerProductAndServiceCategory.module.scss';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';
const PartnerProductAndServiceCategory = () => {
  const [clearModal, setClearModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const onClose = () => {
    setDeleteModal(false);
  };

  const tableData = [
    {
      id: 4,
      partnerName: 'Wakanow',
      type: 'Merchandize Partner',
      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
    {
      id: 2,
      partnerName: 'Wakanow',
      type: 'Merchandize Partner',
      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
    {
      id: 9,
      partnerName: 'Wakanow',
      type: 'Merchandize Partner',
      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
    {
      id: 6,
      partnerName: 'Wakanow',
      type: 'Merchandize Partner',
      address: 'Online Store',
      name: 'Eniola Taiwo',
      number: 8023327843,
      mail: 'tadesola@hotmail.com',
    },
  ];
  return (
    <div>
      <CallCenterStructure>
        <div className={styles.PartnerProductAndServiceCategory}>
          <div className={styles.headerText}>
            <p>Partner Product/Service Category</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.field1}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Select Partner<sup>*</sup>
                </label>
                <Dropdown />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Partner Category<sup>*</sup>
                </label>
                <input type="text" />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Enter Product/Service Category<sup>*</sup>
                </label>
                <input type="text" />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <button className={styles.submit}>Submit</button>
              <button
                className={styles.reset}
                type="button"
                onClick={() => setClearModal(true)}>
                Reset
              </button>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.searchInputContainer}>
              <div className={styles.searchInput}>
                <SearchInput />
              </div>
              <button className={styles.search}>search</button>
            </div>
            <div className={styles.tableContainer}>
              <table className={styles.mainTable}>
                <thead>
                  <tr>
                    <th>Partner Name</th>
                    <th>Product/Service Category</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map(each => (
                    <tr key={each.id}>
                      <td>{each.partnerName}</td>
                      <td>{each.type}</td>

                      <td>
                        <div className={styles.iconContainer}>
                          <span className={styles.icon}>
                            <ViewPen />
                          </span>

                          <span
                            className={styles.icon}
                            onClick={() => setDeleteModal(true)}>
                            <Times />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={styles.pagination}>
              <p>Pagination</p>
            </div>
          </div>
          {/* Pass your clear input function to clearInputFn */}
          <ClearInputModal
            //   clearInputFn={handleReset}
            clearModalStatus={clearModal}
            clearInputModalState={setClearModal}
          />
        </div>
      </CallCenterStructure>
    </div>
  );
};

export default PartnerProductAndServiceCategory;
